/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Food Security Exchange API
 * REST API for the FSE platform. Endpoints by BRS module (PLAN.md §5).
 * OpenAPI spec version: 0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AuditLogPageDto,
  ChangePinDto,
  ChangePinResultDto,
  MeControllerGetAuditLogParams,
  MeControllerGetNotificationsParams,
  MyCooperativeDto,
  MyExportDto,
  MyFarmProfileDto,
  MyNotificationsPageDto,
  MyProfileDto,
  UpdateFarmProfileResultDto,
  UpdateMyFarmProfileDto,
  UpdateMyProfileDto
} from '.././models';

import { fseAxios } from '../../client';




/**
 * Returns the caller's profile (role, phone, display name, preferred language) selected from `users WHERE id = sub`. Phone is read-only. 404 if the user row no longer exists.
 * @summary The signed-in user's own profile
 */
export const meControllerGetProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MyProfileDto>(
      {url: `/me/profile`, method: 'GET', signal
    },
      );
    }
  



export const getMeControllerGetProfileQueryKey = () => {
    return [
    `/me/profile`
    ] as const;
    }

    
export const getMeControllerGetProfileQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetProfile>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetProfile>>> = ({ signal }) => meControllerGetProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MeControllerGetProfileQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetProfile>>>
export type MeControllerGetProfileQueryError = unknown


export function useMeControllerGetProfile<TData = Awaited<ReturnType<typeof meControllerGetProfile>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetProfile>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetProfile<TData = Awaited<ReturnType<typeof meControllerGetProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetProfile>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetProfile<TData = Awaited<ReturnType<typeof meControllerGetProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary The signed-in user's own profile
 */

export function useMeControllerGetProfile<TData = Awaited<ReturnType<typeof meControllerGetProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetProfile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMeControllerGetProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates display name and/or preferred language on the caller's own user row. At least one field is required (empty patch → 400). Phone is NOT editable here. Writes an audit_log row (action=me.profile.update). Returns the updated profile.
 * @summary Edit the signed-in user's own profile
 */
export const meControllerUpdateProfile = (
    updateMyProfileDto: UpdateMyProfileDto,
 ) => {
      
      
      return fseAxios<MyProfileDto>(
      {url: `/me/profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMyProfileDto
    },
      );
    }
  


export const getMeControllerUpdateProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerUpdateProfile>>, TError,{data: UpdateMyProfileDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof meControllerUpdateProfile>>, TError,{data: UpdateMyProfileDto}, TContext> => {

const mutationKey = ['meControllerUpdateProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerUpdateProfile>>, {data: UpdateMyProfileDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerUpdateProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MeControllerUpdateProfileMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerUpdateProfile>>>
    export type MeControllerUpdateProfileMutationBody = UpdateMyProfileDto
    export type MeControllerUpdateProfileMutationError = unknown

    /**
 * @summary Edit the signed-in user's own profile
 */
export const useMeControllerUpdateProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerUpdateProfile>>, TError,{data: UpdateMyProfileDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerUpdateProfile>>,
        TError,
        {data: UpdateMyProfileDto},
        TContext
      > => {

      const mutationOptions = getMeControllerUpdateProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Returns the caller's farm details (tree count, estimated capacity, GPS, principal type, cooperative) from `farmer_profiles WHERE user_id = sub`, LEFT JOINed to `cooperatives` for the name. Read-only. 404 when the caller has no farmer_profile row (e.g. a coop_admin/admin who is not a farmer).
 * @summary The signed-in farmer's own farm details
 */
export const meControllerGetFarmProfile = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MyFarmProfileDto>(
      {url: `/me/farm-profile`, method: 'GET', signal
    },
      );
    }
  



export const getMeControllerGetFarmProfileQueryKey = () => {
    return [
    `/me/farm-profile`
    ] as const;
    }

    
export const getMeControllerGetFarmProfileQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetFarmProfileQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetFarmProfile>>> = ({ signal }) => meControllerGetFarmProfile(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MeControllerGetFarmProfileQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetFarmProfile>>>
export type MeControllerGetFarmProfileQueryError = unknown


export function useMeControllerGetFarmProfile<TData = Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetFarmProfile>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetFarmProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetFarmProfile<TData = Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetFarmProfile>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetFarmProfile>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetFarmProfile<TData = Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary The signed-in farmer's own farm details
 */

export function useMeControllerGetFarmProfile<TData = Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetFarmProfile>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMeControllerGetFarmProfileQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Updates tree count, estimated capacity and/or GPS on the caller's own farmer_profile row. At least one field is required (empty patch → 400). farmGps may be a {lat,lng} pair, or null to clear the stored point; omit it to leave GPS unchanged. estCapacityKg may be null to clear it. 404 when the caller has no farmer_profile row.

The edit BRANCHES on the caller's principal_type: an individual (G1) farmer's edit is applied DIRECTLY (audit action=me.farm.update) and returned with reviewPending=false. A formal-cooperative (G3) or informal-group (G2) member's edit is instead routed to the coop_admin / group_lead review flow as a pending farmer_profile_edit_request; the profile is left unchanged and returned with reviewPending=true.
 * @summary Edit the signed-in farmer's own farm details
 */
export const meControllerUpdateFarmProfile = (
    updateMyFarmProfileDto: UpdateMyFarmProfileDto,
 ) => {
      
      
      return fseAxios<UpdateFarmProfileResultDto>(
      {url: `/me/farm-profile`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updateMyFarmProfileDto
    },
      );
    }
  


export const getMeControllerUpdateFarmProfileMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerUpdateFarmProfile>>, TError,{data: UpdateMyFarmProfileDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof meControllerUpdateFarmProfile>>, TError,{data: UpdateMyFarmProfileDto}, TContext> => {

const mutationKey = ['meControllerUpdateFarmProfile'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerUpdateFarmProfile>>, {data: UpdateMyFarmProfileDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerUpdateFarmProfile(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MeControllerUpdateFarmProfileMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerUpdateFarmProfile>>>
    export type MeControllerUpdateFarmProfileMutationBody = UpdateMyFarmProfileDto
    export type MeControllerUpdateFarmProfileMutationError = unknown

    /**
 * @summary Edit the signed-in farmer's own farm details
 */
export const useMeControllerUpdateFarmProfile = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerUpdateFarmProfile>>, TError,{data: UpdateMyFarmProfileDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerUpdateFarmProfile>>,
        TError,
        {data: UpdateMyFarmProfileDto},
        TContext
      > => {

      const mutationOptions = getMeControllerUpdateFarmProfileMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Verifies the caller's current PIN, then sets a new one and clears any failed-attempt counter / lockout. Both PINs are 4-8 digit strings. Returns 401 when the current PIN is wrong, 400 when the account has no PIN set. PIN values are never logged. Writes an audit_log row (action=me.pin.change) carrying no PIN data.
 * @summary Change the signed-in user's own login PIN
 */
export const meControllerChangePin = (
    changePinDto: ChangePinDto,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<ChangePinResultDto>(
      {url: `/me/change-pin`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changePinDto, signal
    },
      );
    }
  


export const getMeControllerChangePinMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerChangePin>>, TError,{data: ChangePinDto}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof meControllerChangePin>>, TError,{data: ChangePinDto}, TContext> => {

const mutationKey = ['meControllerChangePin'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof meControllerChangePin>>, {data: ChangePinDto}> = (props) => {
          const {data} = props ?? {};

          return  meControllerChangePin(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MeControllerChangePinMutationResult = NonNullable<Awaited<ReturnType<typeof meControllerChangePin>>>
    export type MeControllerChangePinMutationBody = ChangePinDto
    export type MeControllerChangePinMutationError = unknown

    /**
 * @summary Change the signed-in user's own login PIN
 */
export const useMeControllerChangePin = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof meControllerChangePin>>, TError,{data: ChangePinDto}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof meControllerChangePin>>,
        TError,
        {data: ChangePinDto},
        TContext
      > => {

      const mutationOptions = getMeControllerChangePinMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Paginated, privacy-safe audit trail for the caller — rows where they are the actor OR the entity, newest first. Exposes only action, entityKind and occurredAt; IP addresses and before/after diffs are never returned.
 * @summary The signed-in user's own activity trail
 */
export const meControllerGetAuditLog = (
    params?: MeControllerGetAuditLogParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<AuditLogPageDto>(
      {url: `/me/audit-log`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getMeControllerGetAuditLogQueryKey = (params?: MeControllerGetAuditLogParams,) => {
    return [
    `/me/audit-log`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMeControllerGetAuditLogQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError = unknown>(params?: MeControllerGetAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetAuditLogQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetAuditLog>>> = ({ signal }) => meControllerGetAuditLog(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MeControllerGetAuditLogQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetAuditLog>>>
export type MeControllerGetAuditLogQueryError = unknown


export function useMeControllerGetAuditLog<TData = Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError = unknown>(
 params: undefined |  MeControllerGetAuditLogParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetAuditLog>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetAuditLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetAuditLog<TData = Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError = unknown>(
 params?: MeControllerGetAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetAuditLog>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetAuditLog>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetAuditLog<TData = Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError = unknown>(
 params?: MeControllerGetAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary The signed-in user's own activity trail
 */

export function useMeControllerGetAuditLog<TData = Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError = unknown>(
 params?: MeControllerGetAuditLogParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetAuditLog>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMeControllerGetAuditLogQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Bundles the caller's profile, farm profile (null for non-farmers), contributions (capped at 1000) and privacy-safe audit trail (capped at 1000) into one JSON envelope. All data is self-scoped to the caller.
 * @summary POPIA data-portability export of the caller's own data
 */
export const meControllerExport = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MyExportDto>(
      {url: `/me/export`, method: 'GET', signal
    },
      );
    }
  



export const getMeControllerExportQueryKey = () => {
    return [
    `/me/export`
    ] as const;
    }

    
export const getMeControllerExportQueryOptions = <TData = Awaited<ReturnType<typeof meControllerExport>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerExportQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerExport>>> = ({ signal }) => meControllerExport(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerExport>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MeControllerExportQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerExport>>>
export type MeControllerExportQueryError = unknown


export function useMeControllerExport<TData = Awaited<ReturnType<typeof meControllerExport>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerExport>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerExport>>,
          TError,
          Awaited<ReturnType<typeof meControllerExport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerExport<TData = Awaited<ReturnType<typeof meControllerExport>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerExport>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerExport>>,
          TError,
          Awaited<ReturnType<typeof meControllerExport>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerExport<TData = Awaited<ReturnType<typeof meControllerExport>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerExport>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary POPIA data-portability export of the caller's own data
 */

export function useMeControllerExport<TData = Awaited<ReturnType<typeof meControllerExport>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerExport>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMeControllerExportQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A READ-ONLY view over audit_log (no new table, no read/unread state — the client tracks "last seen" locally). Surfaces curated actions where SOMEONE ELSE acted on the caller: KYC review, offers/orders and demand-board activity. Privacy-safe — only id, kind, occurredAt and a derived title; never before/after diffs or IPs. Newest first, paginated.
 * @summary A derived feed of things others did to the caller
 */
export const meControllerGetNotifications = (
    params?: MeControllerGetNotificationsParams,
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MyNotificationsPageDto>(
      {url: `/me/notifications`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getMeControllerGetNotificationsQueryKey = (params?: MeControllerGetNotificationsParams,) => {
    return [
    `/me/notifications`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getMeControllerGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetNotifications>>, TError = unknown>(params?: MeControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetNotifications>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetNotifications>>> = ({ signal }) => meControllerGetNotifications(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MeControllerGetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetNotifications>>>
export type MeControllerGetNotificationsQueryError = unknown


export function useMeControllerGetNotifications<TData = Awaited<ReturnType<typeof meControllerGetNotifications>>, TError = unknown>(
 params: undefined |  MeControllerGetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetNotifications>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetNotifications<TData = Awaited<ReturnType<typeof meControllerGetNotifications>>, TError = unknown>(
 params?: MeControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetNotifications>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetNotifications>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetNotifications<TData = Awaited<ReturnType<typeof meControllerGetNotifications>>, TError = unknown>(
 params?: MeControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary A derived feed of things others did to the caller
 */

export function useMeControllerGetNotifications<TData = Awaited<ReturnType<typeof meControllerGetNotifications>>, TError = unknown>(
 params?: MeControllerGetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetNotifications>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMeControllerGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Returns the caller's current cooperative (null when independent / G1), their principal_type, and any open JOIN request (null when none pending). 404 when the caller has no farmer_profile row.
 * @summary The signed-in farmer's current cooperative affiliation
 */
export const meControllerGetCooperative = (
    
 signal?: AbortSignal
) => {
      
      
      return fseAxios<MyCooperativeDto>(
      {url: `/me/cooperative`, method: 'GET', signal
    },
      );
    }
  



export const getMeControllerGetCooperativeQueryKey = () => {
    return [
    `/me/cooperative`
    ] as const;
    }

    
export const getMeControllerGetCooperativeQueryOptions = <TData = Awaited<ReturnType<typeof meControllerGetCooperative>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetCooperative>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMeControllerGetCooperativeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof meControllerGetCooperative>>> = ({ signal }) => meControllerGetCooperative(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof meControllerGetCooperative>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type MeControllerGetCooperativeQueryResult = NonNullable<Awaited<ReturnType<typeof meControllerGetCooperative>>>
export type MeControllerGetCooperativeQueryError = unknown


export function useMeControllerGetCooperative<TData = Awaited<ReturnType<typeof meControllerGetCooperative>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetCooperative>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetCooperative>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetCooperative>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetCooperative<TData = Awaited<ReturnType<typeof meControllerGetCooperative>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetCooperative>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof meControllerGetCooperative>>,
          TError,
          Awaited<ReturnType<typeof meControllerGetCooperative>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useMeControllerGetCooperative<TData = Awaited<ReturnType<typeof meControllerGetCooperative>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetCooperative>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary The signed-in farmer's current cooperative affiliation
 */

export function useMeControllerGetCooperative<TData = Awaited<ReturnType<typeof meControllerGetCooperative>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof meControllerGetCooperative>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getMeControllerGetCooperativeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




